/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCreateApiKey
 */
export interface MelcoModelsCreateApiKey {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateApiKey
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateApiKey
     */
    sub_group?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateApiKey
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateApiKey
     */
    scope_id?: string | null;
}

export function MelcoModelsCreateApiKeyFromJSON(json: any): MelcoModelsCreateApiKey {
    return MelcoModelsCreateApiKeyFromJSONTyped(json, false);
}

export function MelcoModelsCreateApiKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCreateApiKey {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'sub_group': !exists(json, 'sub_group') ? undefined : json['sub_group'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'scope_id': !exists(json, 'scope_id') ? undefined : json['scope_id'],
    };
}

export function MelcoModelsCreateApiKeyToJSON(value?: MelcoModelsCreateApiKey | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'sub_group': value.sub_group,
        'product_code': value.product_code,
        'scope_id': value.scope_id,
    };
}


